import Fixture from '~/components/atoms/Fixture/Fixture'
import SignupPageComp from '~/components/blocks/SignupPage/SignupPage'

import type { PageTemplateModule } from './types'

/**
 * Signup Template Component
 * Renders the signup page with the SignupPageComp
 */
function SignupTemplate({ data }: { data: any }) {
  // data contains all the page props including body array
  // SignupPageComp expects the entire data object spread, plus pageBlocks
  return (
    <Fixture>
      <SignupPageComp {...data} pageBlocks={data.body} />
    </Fixture>
  )
}

/**
 * Signup Page Template Module
 * No additional data fetching needed - uses base page data
 */
export const signupTemplate: PageTemplateModule = {
  async fetchData() {
    // Signup page doesn't need additional data beyond base page query
    return {}
  },

  component: SignupTemplate,
}
